// extracted by mini-css-extract-plugin
module.exports = {"section":"Section__section--G5G7U","sectionCaption":"Section__sectionCaption--ei3ya","sectionGroup":"Section__sectionGroup--d4-zd"};